<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuth } from "../composables/useAuth";

const router = useRouter();
const { login } = useAuth();

const account = ref("");
const password = ref("");
const showPwd = ref(false);
const busy = ref(false);
const error = ref("");

async function handleLogin(): Promise<void> {
  if (!account.value.trim() || !password.value.trim()) {
    error.value = "请输入手机号（管理员可使用原账号）和密码";
    return;
  }
  busy.value = true; error.value = "";
  try {
    await login(account.value, password.value);
    router.replace("/current-coaches");
  } catch (e) {
    error.value = e instanceof Error ? e.message : "登录失败";
  } finally { busy.value = false; }
}
</script>

<template>
  <main class="login-shell">
    <form class="login-card" @submit.prevent="handleLogin">
      <h1>七天营运营工作台</h1>

      <p class="hint">一次登录，按账号已配置的角色进入对应工作入口。</p>

      <p v-if="error" class="alert">{{ error }}</p>

      <input
        v-model="account" type="text" inputmode="numeric" class="pwd-input phone-input"
        placeholder="手机号码（管理员可用原账号）" :disabled="busy" autofocus
      />
      <div class="pwd-wrap">
        <input v-model="password" :type="showPwd ? 'text' : 'password'" class="pwd-input" placeholder="密码" :disabled="busy" autofocus />
        <button type="button" class="pwd-toggle" @click="showPwd = !showPwd" tabindex="-1">{{ showPwd ? '👁' : '🙈' }}</button>
      </div>

      <button class="login-btn" type="submit" :disabled="busy || !password.trim()">
        {{ busy ? "登录中..." : "登录" }}
      </button>
    </form>
  </main>
</template>

<style scoped>
.login-shell { display:grid; place-items:center; min-height:100vh; padding:24px; background:#f5f7fb; }
.login-card {
  width:min(400px,100%); padding:36px 32px; border:1px solid #dfe5ee; border-radius:12px;
  background:#fff; box-shadow:0 10px 28px rgba(15,23,42,.06); text-align:center;
}
.login-card h1 { margin:0 0 24px; font-size:24px; color:#0f172a; }

.hint { margin:0 0 14px; color:#94a3b8; font-size:13px; }

.alert { margin-bottom:14px; padding:10px 12px; border:1px solid #fecaca; border-radius:8px; color:#991b1b; background:#fff1f2; font-size:14px; }

.pwd-wrap { position:relative; margin-bottom:14px; }
.pwd-wrap .pwd-input { margin-bottom:0; padding-right:48px; }
.pwd-toggle { position:absolute; right:8px; top:50%; transform:translateY(-50%); border:none; background:transparent; font-size:20px; cursor:pointer; padding:4px; line-height:1; }
.pwd-input {
  width:100%; height:48px; padding:0 14px;
  border:1px solid #d8dee8; border-radius:8px; font-size:16px; outline:none; text-align:center;
}
.phone-input { margin-bottom:10px; }
.pwd-input:focus { border-color:#cf7a42; box-shadow:0 0 0 3px rgba(212,120,58,.1); }

.login-btn {
  width:100%; height:48px; border:none; border-radius:8px; background:#0f172a;
  color:#fff; font-size:16px; font-weight:700; cursor:pointer;
}
.login-btn:disabled { opacity:.6; cursor:wait; }
</style>
